// extracted by mini-css-extract-plugin
export default {"success":"Text_success__0ExgA","error":"Text_error__lYKx6"};